// extracted by mini-css-extract-plugin
module.exports = {"container":"PlaceNewOrder_container__Xjzw1","title":"PlaceNewOrder_title__CZ4gn"};